export default __webpack_public_path__ + "static/media/homepage_module_themes.8fc065de.png";